// extracted by mini-css-extract-plugin
export default {"main":"Yo1GtSa7xVRDqjlYz16L","container":"qbcaeDP67Tt2DhdGVEqg","description":"_ZzugisqffUGWL3rEfsk","terms":"vMCkNWHsycfXa0fVZkUC","button":"kU4kkFs_kivycFGRZlV5"};